import { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import SuggesctionCard from "./SuggesctionCard";
import API_ENDPOINT from "../wm.api.service";
import { connect } from "react-redux";
import axios from "axios";
import Cookies from "universal-cookie";
import { decode } from "base-64";
const Cookie = new Cookies();
function Suggestion({ className, isMobile, rootData}) {
  var token = Cookie.get("wmtoken");
  const [users, setUsers] = useState([]);
  const getSuggestion = () => {
    var fd = new FormData();
    if (token) {
      fd.append("token", decode(token));
      fd.append("identity", API_ENDPOINT.identity);
      fd.append("username", rootData.username);
      axios({
        method: "POST",
        url: `${API_ENDPOINT.apiURL}Profile/suggestUsers`,
        data: fd,
      })
        .then(function (response) {
          setUsers(response.data);
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  };
  const getTrending = () => {
    var fd = new FormData();
    fd.append("screen", "USER");
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Profile/getTrending`,
      data: fd,
    })
      .then(function (response) {
        setUsers(response.data);
      })
      .catch(function (err) {
        console.log(err);
      });
  };
  const getUserSuggestions = () => {
    if (token) {
      getSuggestion();
    } else {
      getTrending();
    }
  };
  useEffect(() => {
    getUserSuggestions();
  }, []);
  return (
    <>
      <div className={`${className} hidden`}>
        <div className="rounded shadow py-3 bg-white">
          <span className="manpro font-normal block text-gray-600 text-lg mx-3 pb-2 border-b border-solid border-gray-300 uppercase">
            {token ? "Suggestions" : "Top Trendings"}
          </span>
          {isMobile ? (
            <Container fluid className="overflow-auto">
              <div className="-mx-4 flex overflow-auto whitespace-nowrap">
                {users.map((userData, idx) => {
                  return <SuggesctionCard key={idx} userdata={userData} isMobile/>;
                })}
              </div>
            </Container>
          ) : (
            <Container fluid>
              <Row>
                {users.slice(0, 3).map((userData, idx) => {
                  return <SuggesctionCard key={idx} userdata={userData} />;
                })}
              </Row>
            </Container>
          )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps, null)(Suggestion);
